module.exports = __webpack_public_path__ + "img/18.c49f82f1.png";